import styled from 'styled-components'

export const Header = styled.header`
    grid-row: header;
`